import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  StyledParcelEvent,
  StyledDate,
  StyledDesc,
  StyledUser,
  StyledEventRow,
  StyledIconDot,
  StyledBoxInteriorButtonMessage,
  ButtonsEvent,
  StyledTag
} from './styleEvent';
import { StyledIconOptions } from './style';

/** Utils */
import { navigateToFile } from '../../../utils/navigate';
import { Share } from '../../../../assets/images/index';

/** API */
import {
  setParcelAction,
  checkViewedByContent
} from '../../../utils/apiHeader';

/** Models */
import { dataNotificationsModel } from '../../../utils/models';

/** Constants */
const STATUS = {
  VALIDATE_PENDING_PARCEL_STAFF: 'PENDIENTE',
  VALIDATE_PENDING_SSGG: 'PENDIENTE',
  AUTHORIZE_PENDING: 'PENDIENTE',
  REJECTED: 'RECHAZADO'
};

const ACTIONS = {
  AUTHORIZE: 'AUTORIZAR',
  VALIDATE_BY_GENERAL_SERVICES: 'VALIDAR',
  VALIDATE_BY_PARCEL_STAFF: 'VALIDAR',
  REJECT: 'RECHAZAR'
};

const prod = window.API_URL === 'https://intranetapi.atresmedia.com/';
const APP_URL = prod
  ? 'https://a3mil.atresmedia.com/paqueteria/shipment_list/'
  : 'https://a3milpre.atresmedia.com/paqueteria/shipment_list/';

class ParcelNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOptions: {}
    };
  }

  executeAction = (action, stateContent, contentId) => {
    const { update } = this.props;
    // Execute the action on the parcel
    setParcelAction(action, stateContent, contentId).then(() => {
      // Set this notification as viewed
      checkViewedByContent(contentId);
      update();
    });
  };

  // Open the parcel app to see the content
  goToContent = contentId => {
    const { update } = this.props;
    navigateToFile(`${APP_URL}${contentId}`, '_self');
    checkViewedByContent(contentId).then(() => {
      update();
    });
  };

  handleShowOptions(id) {
    const { showOptions } = this.state;
    this.setState({
      showOptions: {
        ...showOptions,
        [id]: showOptions[id] ? !showOptions[id] : true
      }
    });
  }

  render() {
    const { data } = this.props;
    const { showOptions } = this.state;

    return data.map(item => (
      <StyledParcelEvent className="notification" key={item.id} tabIndex="0">
        <StyledEventRow>
          <StyledIconDot viewed={item.viewed} />
          <StyledDate className="notification-date">{item.sendDate}</StyledDate>
          <StyledUser className="notification-title">
            {item.creationUser}
          </StyledUser>
        </StyledEventRow>
        <StyledEventRow>
          <StyledDesc>{item.description}</StyledDesc>
          {item.viewed && <StyledTag>{STATUS[item.stateContent]}</StyledTag>}
          <StyledIconOptions
            onClick={() => this.handleShowOptions(item.id)}
            size="l"
            color="dark"
            svg={Share}
          />
        </StyledEventRow>
        <StyledBoxInteriorButtonMessage
          className="notification-box"
          showOptions={showOptions[item.id]}
        >
          {item.actionsUser.length > 0 &&
            item.actionsUser.map(action => (
              <ButtonsEvent
                className="widget-hide"
                key={action}
                onClick={() =>
                  this.executeAction(action, item.stateContent, item.contentId)
                }
                ghost
              >
                {ACTIONS[action]}
              </ButtonsEvent>
            ))}
          <ButtonsEvent onClick={() => this.goToContent(item.contentId)} ghost>
            {'VER'}
          </ButtonsEvent>
          <ButtonsEvent onClick={() => this.handleShowOptions(item.id)} ghost>
            {'CERRAR'}
          </ButtonsEvent>
        </StyledBoxInteriorButtonMessage>
      </StyledParcelEvent>
    ));
  }
}

ParcelNotifications.propTypes = {
  update: PropTypes.func,
  data: dataNotificationsModel
};

export default ParcelNotifications;
